import React, { useCallback, useEffect, useState } from 'react';
import { AppRoutes } from '../../constants/route';
import { ChangeRequest, Result } from '../../interfaces/changeRequest';
import {
  getChangeRequestTitle,
  isOwnChangeRequest,
} from '../../services/changeRequestService';
import { OrgCredential } from '../../interfaces/organization';
import { NOT_OWN_CHANGE_REQUEST } from '../../constants/texts';
import MenuSubItem from './MenuSubItem';
import { MenuProps } from 'antd';

type ChangeRequestItemProps = {
  changeRequest: Result;
  org: OrgCredential | null;
  actions?: MenuProps['items'];
  getActions?: (cr: ChangeRequest) => MenuProps['items'];
  isEditingTitle: boolean;
  onTitleChange: (cr: ChangeRequest, title: string) => void;
  onAbortTitleChange: () => void;
};

const ChangeRequestItem: React.FC<ChangeRequestItemProps> = ({
  changeRequest,
  org,
  actions,
  getActions,
  isEditingTitle,
  onTitleChange,
  onAbortTitleChange,
}) => {
  const isOwnCr = isOwnChangeRequest(org, changeRequest);
  const changeRequestPath = `${AppRoutes.changeRequests.path}/${changeRequest.id}`;
  const changeRequestTitle = getChangeRequestTitle(changeRequest);
  const [allActions, setAllActions] = useState<MenuProps['items']>([]);
  useEffect(() => {
    let _actions: MenuProps['items'] = [];
    if (actions) {
      _actions = actions;
    } else if (getActions) {
      _actions = getActions(changeRequest);
    }
    setAllActions(_actions);
  }, [actions, getActions]);

  const handleOnTitleChange = useCallback(
    (newTitle: string) => onTitleChange(changeRequest, newTitle),
    [onTitleChange, changeRequest]
  );

  return (
    <MenuSubItem
      label={changeRequestTitle}
      editableTitle={changeRequest.name || ''}
      path={changeRequestPath}
      actions={allActions}
      tooltip={!isOwnCr ? NOT_OWN_CHANGE_REQUEST : changeRequestTitle}
      isReadOnly={!isOwnCr}
      isEditingTitle={isEditingTitle}
      onTitleChange={handleOnTitleChange}
      onAbortTitleChange={onAbortTitleChange}
    />
  );
};

export default ChangeRequestItem;
